import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    Resolve,
    RouterStateSnapshot,
} from '@angular/router';
import { combineLatest, Observable, of } from 'rxjs';
import { map, switchMap, tap, take, mergeMap } from 'rxjs/operators';
import { ChoiceListService } from 'src/app/acl-data/choice-list/choice-list.service';
import { FolderService } from 'src/app/acl-data/folder/folder.service';

@Injectable({
    providedIn: 'root',
})
export class BrowseResolverService implements Resolve<any> {
    constructor(
        private choiceListService: ChoiceListService,
        private folderService: FolderService
    ) {}

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<any> | Observable<never> {
        // console.log('Browse resolver', route.paramMap);

        const objectStore = route.data.parentMenu.data.id;
        // console.log('ObjectStore:', objectStore);
        const folderID = route.paramMap.get('folderID');
        console.log('Folder ID:', folderID);

        return combineLatest([
            this.choiceListService.getByID(
                objectStore,
                'ContractStatuses',
                undefined
            ),
            this.folderService.getByID(objectStore, null), // Always need root folder
            this.folderService
                .getByID(objectStore, folderID)
                .pipe(
                    mergeMap(v =>
                        this.folderService.getByIds(objectStore, v.subFolders)
                    )
                ),
        ]).pipe(
            map(_ => route.data)
            // tap(v => console.log('Resolve', v))
        );

        // return of(route.data);
    }
}
